const StaresIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      opacity="0.4"
      d="M3.8609 11.9C4.04903 11.8934 4.19996 11.7403 4.19996 11.55V9.09997H6.99996C7.19246 9.09997 7.34996 8.94247 7.34996 8.74997V5.59997H10.15C10.3425 5.59997 10.5 5.44247 10.5 5.24997V2.79997H12.95C13.1425 2.79997 13.2978 2.64466 13.3 2.45435V10.5C13.3 11.2722 12.6722 11.9 11.9 11.9H3.8609Z"
      fill="#011851"
      fillOpacity="0.5"
    />
    <path
      d="M9.80001 2.44985C9.80001 2.25735 9.95751 2.09985 10.15 2.09985H12.95C13.1425 2.09985 13.3 2.25735 13.3 2.44985C13.3 2.64235 13.1425 2.79985 12.95 2.79985H10.5V5.24985C10.5 5.44235 10.3425 5.59985 10.15 5.59985H7.35001V8.74985C7.35001 8.94235 7.19251 9.09985 7.00001 9.09985H4.20001V11.5499C4.20001 11.7424 4.04251 11.8999 3.85001 11.8999H1.05001C0.857512 11.8999 0.700012 11.7424 0.700012 11.5499C0.700012 11.3574 0.857512 11.1999 1.05001 11.1999H3.50001V8.74985C3.50001 8.55735 3.65751 8.39985 3.85001 8.39985H6.65001V5.24985C6.65001 5.05735 6.80751 4.89985 7.00001 4.89985H9.80001V2.44985Z"
      fill="#011851"
    />
  </svg>
);

export default StaresIcon;
